import React from "react";
import Header from "../components/Header";
import RBVesselBranch from "../components/RBVesselBranch";

/**
 * Legacy /dashboard route — kept for backwards compatibility.
 * Renders the RB Vessel Performance branch standalone (same content users are
 * familiar with). New primary entry is /portal (Grindrod Richards Bay Management Portal).
 */
export default function Dashboard() {
    return (
        <div className="min-h-screen">
            <Header />
            <main className="max-w-[1600px] mx-auto px-5 py-6">
                <RBVesselBranch />
            </main>
        </div>
    );
}
